import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { auth } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";

export default function ProtectedRoute({ children }) {
  const [loading, setLoading] = useState(true);
  const [authorized, setAuthorized] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setAuthorized(true); // user is logged in
      } else {
        setAuthorized(false); // user not logged in
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) return <div style={{ height: "100vh", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>Loading...</div>;
  if (!authorized) return <Navigate to="/" replace />; // redirect non-auth users

  return children;
}
